import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, createCommentVNode as _createCommentVNode } from "vue"
import _imports_0 from '@/assets/img/icon/tablet-outline-black.svg'
import _imports_1 from '@/assets/img/icon/mail-outline-black.svg'


const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "grid grid-cols-1 md:grid-cols-10" }
const _hoisted_3 = { class: "col-span-1 md:col-span-9" }
const _hoisted_4 = { class: "md:flex items-center" }
const _hoisted_5 = { class: "self-baseline" }
const _hoisted_6 = ["src"]
const _hoisted_7 = { class: "md:px-4 flex flex-col w-full" }
const _hoisted_8 = { class: "sm:flex pb-3 justify-between" }
const _hoisted_9 = { class: "flex md:hidden gap-4 items-center" }
const _hoisted_10 = ["onClick"]
const _hoisted_11 = { class: "block md:flex items-center body" }
const _hoisted_12 = { class: "px-2 block md:flex items-center border-none md:border-solid border-r border-neutral-400 gap-4" }
const _hoisted_13 = { class: "flex items-center gap-1" }
const _hoisted_14 = { class: "px-2 hidden md:flex items-center" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1)
const _hoisted_16 = { class: "px-2 hidden md:flex items-center" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: ""
}, null, -1)
const _hoisted_18 = { class: "hidden md:flex flex-col justify-between items-end" }
const _hoisted_19 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InlineSvg = _resolveComponent("InlineSvg")!
  const _component_Card = _resolveComponent("Card")!
  const _component_HjpDataList = _resolveComponent("HjpDataList")!
  const _component_ListActions = _resolveComponent("ListActions")!
  const _component_OverlayPanel = _resolveComponent("OverlayPanel")!

  return (!_ctx.isLoading)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_HjpDataList, _normalizeProps(_guardReactiveProps(_ctx.params)), {
          content: _withCtx(({ dataItems }) => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(dataItems, (data, idx) => {
              return (_openBlock(), _createBlock(_component_Card, {
                class: "card-item mb-6 wrap-card-route",
                key: idx
              }, {
                content: _withCtx(() => [
                  _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("div", _hoisted_3, [
                      _createElementVNode("div", _hoisted_4, [
                        _createElementVNode("div", _hoisted_5, [
                          _createElementVNode("img", {
                            class: "self-baseline",
                            src: data.latestEmployment?.isActive ? require('@/assets/img/icon/mandoran-active.png') : require('@/assets/img/icon/mandoran-inactive.png'),
                            style: {"min-width":"40px","height":"40px"},
                            alt: ""
                          }, null, 8, _hoisted_6)
                        ]),
                        _createElementVNode("div", _hoisted_7, [
                          _createElementVNode("div", _hoisted_8, [
                            _createElementVNode("p", {
                              class: _normalizeClass(["text-2xl title font-bold self-baseline", data.latestEmployment?.isActive ? '' : 'text-grey'])
                            }, _toDisplayString(`${data.fullName}`), 3),
                            _createElementVNode("div", _hoisted_9, [
                              _createElementVNode("i", {
                                class: "pi pi-ellipsis-h text-base cursor-pointer color-dark",
                                onClick: ($event: any) => (_ctx.showDropDown($event, data))
                              }, null, 8, _hoisted_10)
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_11, [
                            _createElementVNode("div", _hoisted_12, [
                              _createElementVNode("div", _hoisted_13, [
                                _createVNode(_component_InlineSvg, {
                                  src: require('@/assets/img/icon/nfc-outline-black.svg')
                                }, null, 8, ["src"]),
                                _createElementVNode("p", {
                                  class: _normalizeClass(["items-center text-xs", data.latestEmployment?.isActive ? '' : 'text-grey'])
                                }, "NFC Tag: " + _toDisplayString(data.nfcCardIdentifier ?? '-'), 3)
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_14, [
                              _hoisted_15,
                              _createElementVNode("p", {
                                class: _normalizeClass(["items-center text-xs ml-2", data.latestEmployment?.isActive ? '' : 'text-grey'])
                              }, _toDisplayString(data.phoneNumber ?? '-'), 3)
                            ]),
                            _createElementVNode("div", _hoisted_16, [
                              _hoisted_17,
                              _createElementVNode("p", {
                                class: _normalizeClass(["items-center text-xs ml-2", data.latestEmployment?.isActive ? '' : 'text-grey'])
                              }, _toDisplayString(data.email ?? '-'), 3)
                            ])
                          ])
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_18, [
                      _createElementVNode("i", {
                        class: "pi pi-ellipsis-h text-base cursor-pointer color-dark",
                        onClick: ($event: any) => (_ctx.showDropDown($event, data))
                      }, null, 8, _hoisted_19)
                    ])
                  ])
                ]),
                _: 2
              }, 1024))
            }), 128))
          ]),
          _: 1
        }, 16),
        _createVNode(_component_OverlayPanel, { ref: "op" }, {
          default: _withCtx(() => [
            _createVNode(_component_ListActions, {
              edit: true,
              del: false,
              reset: false,
              resetTitle: "Reset Password",
              editTitle: "Edit Mandoran",
              delTitle: "Hapus Akun",
              onDel: _ctx.onDelete,
              onEdit: _cache[0] || (_cache[0] = ($event: any) => (_ctx.onEdit(_ctx.dataRow.id))),
              onReset: _cache[1] || (_cache[1] = ($event: any) => (_ctx.resetPassword(_ctx.dataRow.id)))
            }, null, 8, ["onDel"])
          ]),
          _: 1
        }, 512)
      ]))
    : _createCommentVNode("", true)
}